import React from "react";

const Marker = ({ text, onClick }: any) => (
  <div onClick={onClick} className="map-marker">
    {text}
  </div>
);

export default Marker;
